import { render, staticRenderFns } from "./GridContactList.vue?vue&type=template&id=5683ddb1&scoped=true"
import script from "./GridContactList.vue?vue&type=script&lang=js"
export * from "./GridContactList.vue?vue&type=script&lang=js"
import style0 from "./GridContactList.vue?vue&type=style&index=0&id=5683ddb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683ddb1",
  null
  
)

export default component.exports